import { SxProps, Theme } from '@mui/material';

/** The line under the title saying where the appointment stands now. */
export const currentWhenStyles: SxProps<Theme> = {
    mb: 2,
};

/** What a patient's move does to a booking or a request, said before they choose. */
export const requestAlertStyles: SxProps<Theme> = {
    mb: 2,
};

/** The patient's instruction above the week strip. */
export const slotHintStyles: SxProps<Theme> = {
    mb: 1,
};

export const fieldStyles: SxProps<Theme> = {
    mt: 1,
};

/** The "it stays 50 minutes long" line under the staff picker. */
export const keepsLengthStyles: SxProps<Theme> = {
    mt: 1,
    display: 'block',
};

/**
 * The blocked-save hint, always shown beside a disabled confirm.
 *
 * A greyed button with no explanation is the complaint the form standard was written
 * against, and this dialog disables its own on two different grounds -- an invalid date on
 * the staff side, no slot chosen on the patient's.
 */
export const blockedHintStyles: SxProps<Theme> = {
    mr: 'auto',
    ml: 1,
};
